'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divider = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _proptypes = require('./proptypes');

var _style = require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var Divider = exports.Divider = function Divider(props) {
  return _react2.default.createElement(
    _style.DividerButtonWrapper,
    props,
    _react2.default.createElement(_style.DividerButton, props)
  );
};

var ButtonGroupWithFeatures = function ButtonGroupWithFeatures(props) {
  var renderChildren = function renderChildren(_ref) {
    var children = _ref.children,
        size = _ref.size,
        outline = _ref.outline;
    return _react2.default.Children.map(children, function (child, i) {
      if (child.type.displayName !== 'Button') {
        throw new Error('The children should be button component');
      }
      var countChildren = _react2.default.Children.count(children);
      var isFirstChild = i === 0;
      var isLastChild = i === countChildren - 1;
      var dividerButton = function dividerButton() {
        if (!isFirstChild) {
          return _react2.default.createElement(Divider, { size: size, outline: outline });
        }
        return null;
      };

      var style = {};

      if (countChildren > 1) {
        if (isFirstChild) {
          style = _style.firstChildStyles;
        } else if (isLastChild) {
          style = _style.lastChildStyles;
        } else {
          style = _style.otherChildStyles;
        }
      }

      return [dividerButton(), _react2.default.createElement(
        child.type,
        (0, _extends3.default)({}, child.props, { style: style, size: size, outline: outline }),
        child.props.children
      )];
    });
  };

  return _react2.default.createElement(
    _style.BeautifulButtonGroup,
    props,
    renderChildren(props)
  );
};

ButtonGroupWithFeatures.propTypes = _proptypes.propTypes;
ButtonGroupWithFeatures.defaultProps = _proptypes.defaultProps;

ButtonGroupWithFeatures.displayName = 'ButtonGroup';

exports.default = ButtonGroupWithFeatures;